export default "/wavepaths-logo-dark.svg";